import { Injectable } from "@angular/core";

import { UserSessionService } from "../../../services/user-session/user-session.service";
import { ConfigService } from "../../../services/config/config.service";
import { CustomerModel } from "../../../models/customer-model";
import { InAppBrowserObject } from "@ionic-native/in-app-browser/ngx";
import {
  GameLaunchParams,
  VendorAdapterInterface,
} from "./vendor-adapter-interface";
import { GameViewInterface, ODRController } from "../../odr-controller";

@Injectable()
export class KambiAdapter implements VendorAdapterInterface {
  protected customer: CustomerModel;
  protected sessionToken: string;

  constructor(
    private userSession: UserSessionService,
    private config: ConfigService
  ) {
    this.userSession.getCustomer().subscribe((customer) => {
      this.customer = customer;
      this.sessionToken = this.userSession.getSessionToken();
    });
  }

  public setWindowRef(windowRef: InAppBrowserObject | GameViewInterface): void {
    console.log("ODR: kambi.ts: setWindowRef; not an InAppBrowserObject");
  }

  public getWindowRef(): InAppBrowserObject | GameViewInterface | undefined {
    return undefined;
  }

  public windowStrategy() {
    return "embeddedinpage";
  }

  public shouldDescendIntoDirs() {
    return true;
  }

  public getTagLayout(extGameParams: GameLaunchParams): Promise<Array<any>> {
    return this.config.isLoaded().then( () => {
      let jurisdiction = ODRController.clientAppJurisdiction(this.config.getClientApp());

      const env = this.config.getConfig().FEATURE_KAMBI_ODR_ENV;
      var env_str = "";
      if (env == "cts") {
        env_str = "-cts";
      } else if (env == "ctn") {
        env_str = "-ctn";
      }
      const tag = `${extGameParams.vendor}-${jurisdiction}${env_str}`;
      console.log("ODR: tag = " + tag);
      return [{ loc: "/", tag: tag }];
    })
  }

  public credentials(p: any): Promise<any> {
    console.log(
      "ODR: kambi.ts: credentials; we dont need no stinkin credentials."
    );
    return Promise.resolve(null);
  }

  public launchODR(
    windowRef: GameViewInterface,
    gamePrms: any
  ): GameViewInterface {
    console.log("ODR: kambi.ts: launchODR; no launch method required, thanks.");
    return null;
  }

  public onGameClosed(windowRef: InAppBrowserObject, closedCb: () => void) {
    console.log("ODR: kambi.ts: onGameClosed; not an InAppBrowserObject");
  }
}
